export default __webpack_public_path__ + "static/media/DriversImage.d3cc841e.svg";